import { render, staticRenderFns } from "./goodsSetting.vue?vue&type=template&id=6b4ac03b&scoped=true&"
import script from "./goodsSetting.vue?vue&type=script&lang=js&"
export * from "./goodsSetting.vue?vue&type=script&lang=js&"
import style1 from "./goodsSetting.vue?vue&type=style&index=1&id=6b4ac03b&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ac03b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4ac03b')) {
      api.createRecord('6b4ac03b', component.options)
    } else {
      api.reload('6b4ac03b', component.options)
    }
    module.hot.accept("./goodsSetting.vue?vue&type=template&id=6b4ac03b&scoped=true&", function () {
      api.rerender('6b4ac03b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/marketingTools/distribution/setting/goodsSetting.vue"
export default component.exports